module.exports = __webpack_public_path__ + "ui-map-marker-depot.e0f1a6ba.png";


//////////////////
// WEBPACK FOOTER
// ../statics/assets/img/map-markers/ui-map-marker-depot.png
// module id = 2545
// module chunks = 1